import { define } from 'wicked-elements'

define('[data-component="play-pause"]', {
  init() {
    this.video = this.element.previousElementSibling
    this.handleClick = this.handleClick.bind(this)
    this.handlePlay = this.handlePlay.bind(this)
    this.handlePause = this.handlePause.bind(this)
  },
  connected() {
    if (this.video) {
      this.video.addEventListener('play', this.handlePlay)
      this.video.addEventListener('pause', this.handlePause)
      this.element.addEventListener('click', this.handleClick)
    }
  },
  disconnected() {
    if (this.video) {
      this.video.removeEventListener('play', this.handlePlay)
      this.video.removeEventListener('pause', this.handlePause)
      this.element.removeEventListener('click', this.handleClick)
    }
  },
  handlePlay() {
    this.element.innerHTML = '⏸'
    this.element.setAttribute('aria-pressed', 'false')
  },
  handlePause() {
    this.element.innerHTML = '▹'
    this.element.setAttribute('aria-pressed', 'true')
  },
  handleClick() {
    if (this.video.paused) {
      this.video.play()
    } else {
      this.video.pause()
    }
  },
})
